/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Filter_ClassInputs */



/**

* @param {_Filter_ClassInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _filter_class = /** @type {((inputs?: _Filter_ClassInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Filter_ClassInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("filtern")
});